import { Color } from '@technology/web3d';

export const MAP_STATION_PLANE_SIZE = 1.1;
export const MAP_STATION_POINT_SIZE = 0.7;
export const DEFAULT_STATION_POINT_SIZE = 0.9;
export const MAP_STATION_NEAR_BOUNDARY = 5;
export const MAP_STATION_FAR_BOUNDARY = 40;

// Outer ring size: higher value = smaller outer ring (transition starts closer to edge)
// Range: 0-0.5, where 0.5 would have no outer ring at all
export const MAP_STATION_OUTER_RING_UV_DIST = 0.43;

// eslint-disable-next-line no-magic-numbers
export const MAP_STATION_MARKER_COLOR = new Color(1, 1, 1);
// eslint-disable-next-line no-magic-numbers
export const MAP_STATION_MARKER_OUTER_RING_COLOR = new Color(0.07, 0.44, 0.55);
// eslint-disable-next-line no-magic-numbers
export const MAP_STATION_ARROW_COLOR = new Color(0.2, 0.2, 0.2);

export const MAP_STATION_INNER_RING_OPACITY = 0.8;
export const MAP_STATION_OUTER_RING_OPACITY = 1.0;
export const MAP_STATION_ARROW_OPACITY = 0.6;

// eslint-disable-next-line no-magic-numbers
export const MAP_STATION_PATH_COLOR = new Color(0.07, 0.44, 0.55);
